const template = document.createElement("template");
template.setAttribute("id", "empty_dialog-template");
template.innerHTML = `<div class="empty_dialog-wrapper empty_dialog-app">
        <div class="empty_dialog-overlay"></div>
        <div class="empty_dialog" data-model="outer">
            <div data-model="message" class="empty_dialog__message"></div>
        </div>
    </div>`;
document.body.appendChild(template);